import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from "@/assets/common/Modal/Modal.vue";
import { WidgetData } from "@/components/Dashboard/Widgets/types/Widget";
import WidgetConfigIncomeAndOutgoAgriFieldGroupPart from './WidgetConfigIncomeAndOutgoAgriFieldGroupPart/WidgetConfigIncomeAndOutgoAgriFieldGroupPart.vue';
import WidgetConfigPlantingBudgetAndActualResultsPart from './WidgetConfigPlantingBudgetAndActualResultsPart/WidgetConfigPlantingBudgetAndActualResultsPart.vue';

@Component({
    components: {
        Modal,
        WidgetConfigIncomeAndOutgoAgriFieldGroupPart,
        WidgetConfigPlantingBudgetAndActualResultsPart
    }
})
export default class WidgetConfig extends Vue {
    private disabled = true
    private valid = true
    private titleMaxLength = 50
    private widget: WidgetData = {
        id: '',
        title: '',
        component: '',
        config: null
    }

    @Prop()
    private value!: boolean

    @Prop()
    private widgetData!: WidgetData

    @Emit('input')
    input(value: boolean): void {
        value
    }

    created(): void {
        this.validate()
    }

    @Watch('value')
    async whenOpen(): Promise<void> {
        this.widget = {
            id: this.widgetData.id,
            title: this.widgetData.title,
            component: this.widgetData.component,
            config : this.widgetData.config
        }
        this.validate()
    }

    @Watch('valid')
    private whenValidate() {
        this.validate()
    }
    @Emit('save')
    private save(): WidgetData {
        return this.widget
    }

    private updateConfig(config: any) {
        this.widget.config = config
    }

    private validate(): void {
        let disabled = false
        if (!this.widget.title || this.widget.title.length > this.titleMaxLength) {
            disabled = true
        }
        if(!this.valid) {
            disabled = true
        }
        this.disabled = disabled
    }

    private cancel() {
        this.input(false)
    }

    get isModalVisible(): boolean {
        return this.value ? this.value : false
    }

    set isModalVisible(value: boolean) {
        this.input(value)
    }
}
